export const textEncoder = window.TextEncoder
  ? new window.TextEncoder()
  : {
      encode: (str: string) =>
        Uint8Array.from(str, (c) => c.codePointAt(0) ?? 0),
    };
